<div class="flex flex-col justify-center gap-1">
  <div class="committee-form-loader">
    <div class="straight"></div>
    <div class="curve"></div>
    <div class="center"></div>
    <div class="inner"></div>
  </div>
  <span class="opacity-60 text-lg">{{ text }}</span>
</div>
